


















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
import moment from 'moment';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'document'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'form', 'formDirty',
      'allRoles'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required, minLength: minLength(3) },
      birthday: { required },
      sex: {},
      department_id: {},
      position_id: {},
      works_since: { required },
      contacts: {},
      fired_at: {},
      loss_rate: {},
    }

    // @ts-ignore
    if (this.form && this.form.credentials) {
      rules.credentials = {
        login: {
          required: requiredIf(function(nestedModel) {
            return nestedModel
          })
        },
        password: {
          required: requiredIf(function(nestedModel) {
            return (nestedModel && !nestedModel.encrypted_password)
          })
        },
        repeatPassword: {
          sameAsPassword: sameAs(function(nestedModel: any, vm: any) {
            return nestedModel ? nestedModel.password : null;
          })
        }
      }

      rules.roles = {}
    }

    return {
      form: rules
    }
  }
})
export default class EmployeeDetails extends Vue {

  document!: any
  form!: any

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log('mounted', this.document, this.document.id)
    if (this.document.id) {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.document.id
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`);
    }
  }

  setFired() {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field: 'fired_at', newValue: moment()
    });
    // @ts-ignore
    this.$v.form['fired_at'].$touch();
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  toggleCredentials(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/toggleCredentials`);

    if (this.$v.form.credentials) {
      // @ts-ignore
      this.$v.form.credentials.$touch();
    }

    // this.$v.form.$touch();
  }

  changeCredentialsValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeCredentialsValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form.credentials[field].$touch();
    // this.$v.form.$touch();
  }

  toggleRoleSelection(roleId: string) {
    this.$store.dispatch(`${STORE_KEY}/toggleRoleSelection`, roleId);

    if (this.$v.form.roles) {
      this.$v.form.roles.$touch();
    }

    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, {
        id: this.document.id
      })
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('on-need-data-reload', result.document.id)
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
